import styled from 'styled-components'

export const SectionItem = styled.div`
  & + & {
    margin-top: 24px;
  }
`
